export * from "./DetailCard";
